export default __webpack_public_path__ + "static/media/linus.1865b018.jpeg";